<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="heading_id_2"><a id="page_iii"></a><strong>The Dangerous Lives of Altar Boys</strong></h1>
<p class="image"><img alt="Image" src="Images/comman.jpg"/></p>
<p class="author"><strong>A Novel by Chris Fuhrman</strong></p>
<p class="image"><img alt="Image" src="Images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?a26b8ca8